import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import PrintHelper from 'print-helper-lib';
import { Nav, NavItem } from 'react-bootstrap';
import BrowserUtils from '../../../utils/BrowserUtils';
import { BDataGrid } from '../../common/dataGrid/BDataGrid';
import ManagePaymentBL from '../ManagePaymentBL';
import { CustomComponentActive } from './CustomComponentActive';
import CancelDirectDebitModal from './CancelDirectDebitModal';
import CancelStandingOrderModal from './CancelStandingOrderModal';
import DateUtils from '../../../utils/DateUtils';
import NumberUtils from '../../../utils/NumberUtils';
import config from '../../../config';
import { ToolTipComponent } from '../../common/ToolTipComponent';
import StringConstant from '../../../constants/StringConstants';
import ManagePaymentActionCreator from '../../../actions/ManagePaymentActionCreator';
import LoaderComponent from '../../common/LoaderComponent';
import SvgIcon from '../../common/SvgIcon';
import UserManagementStore from '../../../stores/UserManagementStore';
import envConfig from '../../../../static/config';

let _isNominatedUser = false;

const columnMeta = [
  {
    columnName: 'fromAccountId',
    order: 1,
    locked: false,
    visible: false,
    displayName: '',
    sortable: false,
  },
  {
    columnName: 'id',
    order: 2,
    locked: false,
    visible: true,
    displayName: 'ID',
    sortable: true,
  },
  {
    columnName: 'fromAccountName',
    order: 3,
    locked: false,
    visible: true,
    displayName: 'From',
    sortable: true,
    cssClassName: 'column-from',
  },
  {
    columnName: 'toAccountName',
    order: 4,
    locked: false,
    visible: true,
    displayName: 'To',
    sortable: true,
    customComponent: CustomComponentActive,
    cssClassName: 'column-to',
  },
  {
    columnName: 'type',
    order: 5,
    locked: false,
    visible: true,
    sortable: true,
    displayName: 'Type ',
    cssClassName: 'column-type',
  },
  {
    columnName: 'amount',
    order: 6,
    locked: false,
    visible: true,
    displayName: 'Amount',
    sortable: true,
    cssClassName: 'column-amount',
    customComponent: CustomComponentActive,
  },
  {
    columnName: 'when',
    order: 7,
    locked: false,
    visible: true,
    displayName: 'Last paid/ Next due',
    sortable: true,
    customComponent: CustomComponentActive,
    cssClassName: 'column-when',
  },
  {
    columnName: 'option',
    order: 8,
    locked: false,
    visible: true,
    displayName: 'Options',
    sortable: false,
    customComponent: CustomComponentActive,
    cssClassName: 'c-tbl__options',
  },
];

class ActivePaymentList extends React.Component {
  constructor(props) {
    super(props);
    this.onResize = this.onResize.bind(this);
    this.onSort = this.onSort.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.onCustomClick = this.onCustomClick.bind(this);
    this.customLoadingComponent = this.customLoadingComponent.bind(this);
    this.getPaymentType = this.getPaymentType.bind(this);
    this.getPaymentFooterMsg = this.getPaymentFooterMsg.bind(this);
    this.getFooterMessage = this.getFooterMessage.bind(this);
    this.getActiveFooterMsg = this.getActiveFooterMsg.bind(this);

    this.state = {
      isTablet: BrowserUtils.isTabletView(),
      _mergeList: ManagePaymentBL.sortPayment(
        this.props.activeList,
        'fromAccountName',
        'asc'
      ),
      navActiveKey: 1,
      sort: 'fromAccountName',
      sortAscending: 'asc',
      footerMessage: this.getFooterMessage(props.activeList),
    };
  }

  componentWillMount() {
    _isNominatedUser = UserManagementStore.isNominatedUser();
  }

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
  }

  componentWillReceiveProps(nextProps) {
    this.setState((state) => {
      return {
        _mergeList: ManagePaymentBL.sortPayment(
          nextProps.activeList,
          state.sort,
          state.sortAscending
        ),
        footerMessage: this.getFooterMessage(
          nextProps.activeList,
          state.navActiveKey
        ),
      };
    });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  onResize() {
    this.setState(() => {
      return { isTablet: BrowserUtils.isTabletView() };
    });
  }

  getPaymentFooterMsg(selectedKey) {
    switch (selectedKey) {
      case 1:
        return StringConstant.noScheduleFooter;
      case 2:
        return this.props.content.footerDDListMsg;
      case 3:
        return this.props.content.footerSOListMsg;
      case 4:
        return this.props.content.footerOtherListMsg;
      default:
        break;
    }
  }

  getActiveFooterMsg(selectedKey) {
    switch (selectedKey) {
      case 1:
        return this.props.content.activeFooter;
      case 2:
        return this.props.content.footerDDListMsg;
      case 3:
        return this.props.content.footerSOListMsg;
      case 4:
        return this.props.content.footerOtherListMsg;
      default:
        break;
    }
  }

  getFooterMessage(paymentList, selectedKey) {
    if (paymentList && paymentList.length === 0) {
      return this.getPaymentFooterMsg(selectedKey);
    }
    return this.getActiveFooterMsg(selectedKey);
  }

  handleSelect(selectedKey) {
    let filteredList = ManagePaymentBL.filterPaymentList(
      this.props.activeList,
      selectedKey
    );

    filteredList = ManagePaymentBL.sortPayment(
      filteredList,
      this.state.sort,
      this.state.sortAscending
    );

    this.setState({
      navActiveKey: selectedKey,
      _mergeList: filteredList,
      footerMessage: this.getFooterMessage(filteredList, selectedKey),
    });
  }

  onRowClick(row) {
    ManagePaymentActionCreator.setEditPayment(row.props.data);
    ManagePaymentActionCreator.navigateToWebTask('WEB-VIEW-PAYMENT');
  }

  onCustomClick(rowdata, type, e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    switch (type) {
      case 'CANCEL':
        this.setState({
          showCancelPaymentModal: true,
          cancelPaymentData: rowdata,
        });
        break;
      case 'EDIT':
        ManagePaymentActionCreator.setEditPayment(rowdata);
        ManagePaymentActionCreator.editBackReference('WEB-MANAGE-PAYMENT');
        ManagePaymentActionCreator.navigateToWebTask('WEB-EDIT-PAYMENT');
        break;
      case 'VIEW':
        ManagePaymentActionCreator.setEditPayment(rowdata);
        ManagePaymentActionCreator.navigateToWebTask('WEB-VIEW-PAYMENT');
        break;
      default:
        break;
    }
  }

  showNavBar() {
    return (
      <Nav
        bsStyle="pills"
        activeKey={this.state.navActiveKey}
        onSelect={this.handleSelect}
      >
        <NavItem eventKey={1}>All</NavItem>
        <NavItem eventKey={2}>Direct Debits</NavItem>
        <NavItem eventKey={3}>Standing orders</NavItem>
        <NavItem eventKey={4}>Other scheduled payments</NavItem>
      </Nav>
    );
  }

  getPaymentType(navActiveKey) {
    switch (navActiveKey) {
      case 1:
        return StringConstant.noSchedulePayment;
      case 2:
        return this.props.content.emptyDDListMsg;
      case 3:
        return this.props.content.emptySOListMsg;
      case 4:
        return this.props.content.emptyOtherListMsg;
      default:
        break;
    }
  }

  showDesktopView() {
    return (
      <div className="manage-payments-table-container manage-payments-table-container-medium">
        <BDataGrid
          results={this.state._mergeList}
          columns={[
            'fromAccountName',
            'toAccountName',
            'type',
            'amount',
            'when',
            'option',
          ]}
          columnMetadata={columnMeta}
          useCustomPagerComponent="true"
          initialSortAscending
          isFooterEnabled
          onRowClick={this.onRowClick}
          gridFooterCss=""
          initialSortOrder="asc"
          onSort={this.onSort}
          rowClick={this.rowClick}
          initialSort="fromAccountName"
          enableInfiniteScroll
          showNoData
          content={this.props.content}
          rowExpander
          customClick={this.onCustomClick}
          externalIsLoading={this.props.isLoading}
          showPager={false}
          noDataMessage={this.getPaymentType(this.state.navActiveKey)}
          tableClassName="manage-payments-table manage-payments-table-medium manage-payments-table--ellipsis"
          externalLoadingComponent={this.customLoadingComponent}
        />
      </div>
    );
  }

  customLoadingComponent() {
    if (!this.props.hasError) {
      return <LoaderComponent type="small" />;
    } else {
      return (
        <div className="text-center">
          <div className="errormessage">{this.props.errorObject.message}</div>
          <button
            onClick={this.props.clickToReload}
            className="c-btn c-btn--default"
          >
            Retry
          </button>
        </div>
      );
    }
  }

  closeModal() {
    this.setState({ showCancelPaymentModal: false });
  }

  showCancelModal() {
    switch (this.state.cancelPaymentData.category) {
      case 'DD':
        return (
          <CancelDirectDebitModal
            closeModal={this.closeModal}
            cancelPaymentData={this.state.cancelPaymentData}
            content={this.props.content}
          />
        );
      case 'SO':
        return (
          <CancelStandingOrderModal
            closeModal={this.closeModal}
            cancelPaymentData={this.state.cancelPaymentData}
            content={this.props.content}
          />
        );
      default:
        break;
    }
  }

  onSort(sort, sortAscending) {
    const sortedData = ManagePaymentBL.sortPayment(
      this.state._mergeList,
      sort,
      sortAscending
    );
    this.setState({
      _mergeList: sortedData,
      sort,
      sortAscending,
    });
  }

  renderMobileData() {
    const svgimage = (
      <a href="javascript:;" aria-label="Information" role="button">
        <SvgIcon id="icon-Information" width="20px" height="20px" />
      </a>
    );
    const hasSvg = true;

    if (this.props.isLoading) {
      return (
        <div className="accountGridNoTransaction text-center">
          {this.customLoadingComponent()}
        </div>
      );
    } else if (this.state._mergeList.length === 0) {
      return (
        <div className="accountGridNoTransaction text-center">
          <p>{StringConstant.noSchedulePayment}</p>
        </div>
      );
    } else {
      const tableList = _.map(this.state._mergeList, (paymentData) => {
        let endDate = DateUtils.getMomentFromDateString(paymentData.when);
        let showEdit = null;
        let showCancel = null;
        endDate = moment(endDate).format(config.dateFormatTimeline);

        if (endDate === StringConstant.INVALID_DATE)
          endDate = StringConstant.unAvailable;

        let amountToDisplay = _.isNumber(paymentData.amount)
          ? NumberUtils.decimalFormat(paymentData.amount, 3, true)
          : StringConstant.unAvailable;
        switch (paymentData.category) {
          case 'DD':
            if (
              paymentData['showIcon'] &&
              paymentData.showIcon &&
              !_isNominatedUser
            ) {
              showEdit = (
                <ToolTipComponent
                  className="info-icon"
                  trigger="manual"
                  childComponent={svgimage}
                  placement="bottom"
                  hasSvg={hasSvg}
                  popoverChildComponent={
                    <p
                      dangerouslySetInnerHTML={{
                        __html: this.props.content.toolTipMessageDD,
                      }}
                    />
                  }
                />
              );
            }
            break;
          default:
            if (_isNominatedUser) {
              showEdit = '';
              showCancel = '';
            } else {
              showEdit = (
                <a
                  className=""
                  href="javascript:;"
                  onClick={(e) => this.onCustomClick(paymentData, 'EDIT', e)}
                >
                  Edit
                </a>
              );
              showCancel = (
                <a
                  className=""
                  href="javascript:;"
                  onClick={(e) => this.onCustomClick(paymentData, 'CANCEL', e)}
                >
                  Cancel
                </a>
              );
              if (!paymentData.isSoWrite) {
                showEdit = (
                  <ToolTipComponent
                    className="info-icon"
                    trigger="manual"
                    childComponent={svgimage}
                    placement="bottom"
                    hasSvg={hasSvg}
                    popoverChildComponent={
                      <p
                        dangerouslySetInnerHTML={{
                          __html: this.props.content.toolTipMessageComplexSO,
                        }}
                      />
                    }
                  />
                );
              }
            }
        }
        return (
          <table
            className="manage-payments-table manage-payments-table-xsmall"
            cellPadding="0"
            cellSpacing="0"
            onClick={(e) => this.onCustomClick(paymentData, 'VIEW', e)}
          >
            <tbody className="manage-payments-table__is-clickable">
              <tr>
                <th width="100">From</th>
                <td>{paymentData.fromAccountName}</td>
              </tr>
              <tr>
                <th>To</th>
                <td>
                  {paymentData.toAccountName},{paymentData.reference}
                </td>
              </tr>
              <tr>
                <th>Type</th>
                <td>{paymentData.paymentType}</td>
              </tr>
              <tr>
                <th>Amount</th>
                <td>{amountToDisplay}</td>
              </tr>
              <tr>
                {paymentData.category === 'DD' ? (
                  <th>Last&nbsp;paid</th>
                ) : (
                  <th>Next&nbsp;due</th>
                )}
                <td>{endDate}</td>
              </tr>
              <tr>
                <th>Options</th>
                <td>
                  <a className="" href="javascript:;">
                    View
                  </a>
                  &nbsp;&nbsp;{showCancel}&nbsp;&nbsp;{showEdit}
                </td>
              </tr>
            </tbody>
          </table>
        );
      });
      return tableList;
    }
  }

  showMobileView() {
    /* if (this.props.isLoading) {
			this.customLoadingComponent();
		} else {*/
    return (
      <div className="manage-payments-table-container manage-payments-table-container-xsmall">
        {this.renderMobileData()}
      </div>
    );
    // }
  }

  render() {
    return (
      <PrintHelper
        className="web-ui-components print-helper-with-text"
        brandId={envConfig.brandId}
        showPrintTopIcon
        showPrintBottomIcon={false}
      >
        <div className="active-payment">
          {!this.props.isCreditCardUser ? this.showNavBar() : null}
          {this.state.isTablet ? this.showMobileView() : this.showDesktopView()}
          <p className="u-text-center">{this.state.footerMessage}</p>
          {this.state.showCancelPaymentModal ? this.showCancelModal() : null}
        </div>
      </PrintHelper>
    );
  }
}

ActivePaymentList.defaultProps = {
  icon: ['glyphicon glyphicon-remove', 'glyphicon glyphicon-remove'],
  titleName: ['More than one word Tab', 'Tab2'],
  tabContent: ['Default_Props Tab1 Content', 'Tab2 Content'],
  IconFlag: false,
  isCreditCardUser: false,
};
ActivePaymentList.propTypes = {
  isCreditCardUser: PropTypes.bool,
  isLoading: PropTypes.bool,
};
export default ActivePaymentList;
